import { useTranslation } from "react-i18next";
import { ClimateRiskType } from "../../types";
import { climateRiskItems, scaleLevelType } from "../../constants";
import ClimateItem from "../../components/ClimateItem";
import "./ClimateRiskList.css";

interface ClimateRiskListProps {
  climatRisk: any;
  rcpSelection: string;
  riskSelected: ClimateRiskType | null | undefined;
  setRiskSelected: (risk: ClimateRiskType | null) => void;
  getScaleLevel: (item: ClimateRiskType, rcp: string) => scaleLevelType | undefined;
  onRcpChange?: (event: React.MouseEvent<HTMLElement>, newRcp: string) => void;
}

export default function ClimateRiskList({
  climatRisk,
  rcpSelection,
  riskSelected,
  setRiskSelected,
  getScaleLevel,
  onRcpChange,
}: ClimateRiskListProps) {
  const { t } = useTranslation();

  // Tous les risques dans une seule liste
  const allRisks = climateRiskItems;

  const renderRiskItem = (item: ClimateRiskType, index: number) => {
    const scaleLevelValue = getScaleLevel(item, rcpSelection);
    const isDisabled = scaleLevelValue?.num === -1;
    
    return (
      <div
        key={`climate_risk_item_${index}`}
        className={`ClimateRiskItem ${
          item === riskSelected ? "selected" : ""
        } ${isDisabled ? "disabled" : ""}`}
        onClick={() => !isDisabled && setRiskSelected(item)}
        style={{
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.6 : 1
        }}
      >
        <ClimateItem
          type={item.id}
          catnatTypes={item.catnatTypes}
          title={t(item.label)}
          content={
            climatRisk.value &&
            climatRisk.value.risks[item.id] &&
            climatRisk.value.risks[item.id].properties
          }
          catnats={climatRisk?.value?.risks?.catnats}
          events={climatRisk?.value?.risks?.events}
          isValue={climatRisk.status === "idle"}
          rcp={rcpSelection}
          scaleLevel={scaleLevelValue}
        />
      </div>
    );
  };

  return (
    <div className="climate-risk-sections">
      {/* Section unique avec titre et sélection RCP */}
      <div className="risk-section">
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center", 
          marginBottom: "4px",
          paddingBottom: "2px"
        }}>
          <h6 style={{ 
            margin: 0, 
            fontSize: "0.9rem", 
            fontWeight: 600,
            color: "#333"
          }}>
            Risques Naturels
          </h6>
          
          {/* RCP Selection - Compact */}
          {onRcpChange && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ marginRight: "4px", fontSize: "0.7rem" }}>
                RCP:
              </span>
              <div style={{
                display: "flex",
                border: "1px solid #ccc",
                borderRadius: "4px",
                overflow: "hidden"
              }}>
                {[{id: "rcp26", label: "2.6"}, {id: "rcp45", label: "4.5"}, {id: "rcp85", label: "8.5"}].map((rcp) => (
                  <button
                    key={rcp.id}
                    onClick={(e) => onRcpChange(e as any, rcp.id)}
                    style={{
                      padding: "2px 6px",
                      fontSize: "0.7rem",
                      minWidth: "32px",
                      height: "24px",
                      border: "none",
                      backgroundColor: rcpSelection === rcp.id ? "#2196f3" : "#f5f5f5",
                      color: rcpSelection === rcp.id ? "white" : "black",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                  >
                    {rcp.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="climate-risk-list">
          {allRisks.map((item, index) => renderRiskItem(item, index))}
        </div>
      </div>
    </div>
  );
}
